import {swiper, swiperSlide} from 'vue-awesome-swiper';
import {BulmaAccordion, BulmaAccordionItem} from 'vue-bulma-accordion';
import '@/assets/swiper/swiper.css';
import Clappr from '@clappr/player';
import LanguageService from '../../common/language.service';
import TreeStructure from '../TreeStructure.vue';
import TopicService from '@/common/topic.service';
import StreamAgendaUtility from '../../common/StreamAgendaUtility';
import {getFullUrl} from '../../common/UrlUtility';

export default {
  name: 'ExhibitorModalContent',
  components: {
    swiper,
    swiperSlide,
    BulmaAccordion,
    BulmaAccordionItem,
    TreeStructure,
  },
  data() {
    return {
      boothsInFair: [],
      contactsInFair: [],
      pointOfContactsInFair: [],
      mediaInFair: [],
      isVideoModal: false,
      videoModalUrl: '',
      videoModalTitle: '',
      brandsInFair: [],
      currentVideoEmbedHtml: '',
      player: null,
      streamParentWaitTimeout: null,
      interval: null,
      streamAgendaUtility: null,
      isLive: false,
    };
  },
  props: {
    entry: {
      type: Object,
      default: null,
    },
    terminalmode: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: null,
    },
    hallplanPath: {
      type: String,
      default: '',
    },
    existingEntries: {
      type: Array,
      default: [],
    },
    configurations: {
      type: Array,
      required: true,
    },
    view_size_mode: {
      type: Number,
      required: true,
    },
    getFormattedDate: {
      type: Function,
      required: true,
    },
    getFormattedOrganizerSpace: {
      type: Function,
      required: true,
    },
    getFormattedDateTime: {
      type: Function,
      required: true,
    },
    getContacts: {
      type: Function,
      required: true,
    },
    getAvatarImg: {
      type: String,
      required: true,
    },
    isFavourite: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    if (this.entry.portrait_url) {
      this.streamAgendaUtility = new StreamAgendaUtility(this.entry);
      this.streamAgendaUtility.initInterval();

      if (this.streamAgendaUtility.isLive && !this.player) {
        this.initStreamPlayer();
      }
      this.initIntervalForStreamPlayer();
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.streamAgendaUtility) {
      this.streamAgendaUtility.clearInterval();
    }
  },
  methods: {
    getFullUrl,
    initIntervalForStreamPlayer() {
      this.checkAndInitLiveStream();

      this.interval = setInterval(() => {
        this.checkAndInitLiveStream();
      }, this.streamAgendaUtility.UPDATE_INTERVAL);
    },
    checkAndInitLiveStream() {
      if (this.streamAgendaUtility.isLive && !this.player) {
        this.initStreamPlayer();
        this.isLive = true;
      }
    },
    initStreamPlayer() {
      // Check if the player is already initialized
      if (this.player) return;

      // Check if the stream parent container exists
      if (!this.$refs.streamParent) {
        this.streamParentWaitTimeout = setTimeout(() => this.initStreamPlayer(), 100);
        return;
      }

      // Clear the timeout for checking the stream parent container again
      if (this.streamParentWaitTimeout) {
        clearTimeout(this.streamParentWaitTimeout);
      }

      // Initialize the player
      this.player = new Clappr.Player({
        source: this.entry.portrait_url,
        parentId: '#fp-stream-parent',
        width: '100%',
        height: '100%',
        language: navigator.language,
      });
    },
    getTopicTitle(topic) {
      const parts = topic.split('|');
      if (parts.length > 1) {
        return parts[1];
      }
      return topic;
    },
    getTopicService(topic) {
      const parts = topic.split('|');
      const fairId = this.entry.fair_ids[0];
      const config = this.configurations.find(c => c.fair_ids.includes(fairId));
      if (config && parts.length > 1) {
        return TopicService.getTopicColorFrom(config, parts[0], parts[1]);
      }
      return TopicService.getTopicColor(topic);
    },
    getContent(content) {
      const urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      let newContent = content;
      newContent = newContent.replace(urlRegex, (match) => {
        if (match.includes('http')) {
          return `<a href="${match}" target ="_blank">${match}</a>`;
        }
        return `<a href="https://${match}/" target ="_blank">${match}</a>`;
      });
      return newContent;
    },
    showSpeakerDetail(person, speaker) {
      this.$emit('showSpeakerDetail', [person, speaker]);
    },
    setFavourite(entryId) {
      this.$emit('set-favourite', entryId);
    },
    getRole(person) {
      const config = this.configurations.find(c => c.fp_persons.find(p => p.id === person.role) !== undefined);
      if (config) {
        const role = config.fp_persons.find(p => p.id === person.role);
        if (!role) {
          return '-';
        }

        let genderVariant;

        if (role.genderVariants && role.genderVariants[person.salutation]) {
          genderVariant = role.genderVariants[person.salutation];
        }

        if (genderVariant !== undefined && genderVariant !== null) {
          return genderVariant;
        }

        if (role.title !== undefined && role.title !== null) {
          return role.title;
        }
      }
      return '-';
    },
  },
  computed: {
    currentLanguage() {
      return LanguageService.getCurrentTYPO3Language();
    },
  },
};
